<div class="payment-dropin mt-4" *ngIf="accessToken">
  <div class="row">
    <h1 class="text-primary text-primary text-center">Book a Birthday Party!</h1>
    <ua-wizard-stepper [currentStep]=3 (stepChange)="stepChange($event)" [disabledSelect]="!!hideSteps || !!isSpecialEvent"></ua-wizard-stepper>
  </div>

  <div class="fw-bold text-center fs-5 mb-2">
    Payment Information
  </div>
  <div>We will charge a payment of <ua-display-price [amount]="booking?.depositAmount"></ua-display-price> to finalize your party. You will then be emailed a confirmation.</div>

  <!-- Agreement checkboxes (above payment form so Apple Pay can be gated) -->
  <div class="disclaimer fw-bold mt-2">By checking these boxes, I agree to the below terms and conditions.</div>

  <div class="form-check mt-2" *ngIf="!user?.impersonated">
    <input id="documents" type="checkbox" class="form-check-input" [(ngModel)]="documentsAcknowledged">
    <label class="form-check-label disclaimer" for="documents">
      By selecting "Pay", you agree to the <a [href]="eSignatureLink" target="_blank">E-signature agreement</a>,
      <a [href]="termsLink" target="_blank">Terms of Use</a>,
      and <a [href]="privacyLink" target="_blank">Privacy Policy</a>.
    </label>
  </div>
  <div class="form-check mt-2">
    <input id="deposit" type="checkbox" class="form-check-input" [(ngModel)]="depositAcknowledged">
    <label class="form-check-label disclaimer" for="deposit">
      <span *ngIf="brandId === 1">
        A non-refundable payment of <ua-display-price [amount]="booking?.depositAmount"></ua-display-price> is required to secure all birthday events.
        If you cancel the event with more than 72 hours' notice, then you waive the right to the
        deposit but you will not owe anything further for the cancelled event. If you cancel the event
        with less than 72 hours' notice, then, so long as you reschedule the event to occur within 30 days
        of the originally scheduled event, then we will apply the deposit to the cost of the event.
        If you no-show the event, then you waive the right to recover the deposit and authorize us to charge
        your credit card for the full amount of the event. If you walk out on the event prior to payment,
        then you waive the right to recover the deposit and authorize us to charge your credit card for the
        full amount of the event. Group Sales and Private Park Rentals: a 50% non-refundable deposit is required to book.
        If you cancel your event you will forfeit the full deposit.
      </span>
      <span *ngIf="brandId !== 1">
        A non-refundable payment of <ua-display-price [amount]="booking?.depositAmount"></ua-display-price> is required to secure all
        birthday events.
        If you cancel the party with less than a 72
        hour notice, we will work with you to find another date and time to host your party or you will forfeit the full
        deposit. If you choose to reschedule your party and cancel at a later date you will forfeit the full deposit.
        Deposits are applied to the remaining balance at the end of the party.
        <span *ngIf="showSpecialEventText">Group Sales and Private Park Rentals: a 50% non-refundable deposit is required to book. If you cancel your event you
        will forfeit the full deposit.</span>
      </span>
    </label>
  </div>
  <div class="form-check mt-2 mb-4">
    <input id="weather" type="checkbox" class="form-check-input" [(ngModel)]="weatherAcknowledged">
    <label class="form-check-label disclaimer" for="weather">
      Weather: If acts of God or Weather cause the facility to close, your party will be re-scheduled. No refunds will be
      given due to weather or acts of God.
    </label>
  </div>

  <!-- Payment form -->
  <div *ngIf="defaultCard?.isExpired && (!filteredCards || filteredCards.length === 0)"
       class="alert alert-warning text-center mt-2" role="alert">
    Your default payment card (ending in {{defaultCard?.cardNumber?.slice(-4)}}) has expired.<br>
    Please update your payment information.
  </div>
  <!-- [STORE-491] Default card expired but other valid cards exist: tell the user why the
       pre-selected card changed, then let them pick a different card or add a new one. -->
  <div *ngIf="paymentProcessorVersion === 2 && defaultCard?.isExpired && filteredCards && filteredCards.length > 0"
       class="alert alert-warning text-center mt-2" role="alert">
    Your default card (ending in {{defaultCard?.cardNumber?.slice(-4)}}) has expired.<br>
    Please select a different card or add a new one.
  </div>
  <div class="form-check mt-2" *ngIf="paymentProcessorVersion === 2 && defaultCard && !defaultCard.isExpired && filteredCards && filteredCards.length > 0">
    <input [(ngModel)]="useDefaultCard"  (ngModelChange)="onDefaultChanged()"  id="useDefaultCardCheck" type="checkbox" class="form-check-input" />
    <label class="form-check-label disclaimer" for="useDefaultCardCheck">Use Default Payment Information</label>
  </div>
  <ng-container *ngIf="(paymentProcessorVersion === 2 && this.useDefaultCard)">
    <label for="defaultCardNumber">Card Number</label>
    <input id="defaultCardNumber" disabled value="{{walletPrefix(defaultCard)}}{{defaultCard?.cardNumber ?? ''}}" class="form-control"/>
  </ng-container>
  <ng-container *ngIf="(paymentProcessorVersion === 2 && !this.useDefaultCard && this.filteredCards && !this.addNewCard)">
    <select [(ngModel)]="defaultCardValue" class="form-select form-control">
      <option value="" disabled>--Select One--</option>
      <option class="text-dark" [value]="card.id" *ngFor="let card of filteredCards" value="{{card.cardNumber}}">{{walletPrefix(card)}}{{card.bankName}} - {{card.cardNumber}}</option>
    </select>
    <hr>
    <div>
      <button (click)="addPaymentMethodClick()" class="btn btn-primary btn-lg w-100 fw-bold">Add Payment Method</button>
    </div>
  </ng-container>
  <ng-container *ngIf="(paymentProcessorVersion === 2  && !useDefaultCard && addNewCard)">
    <ua-justifi [authToken]="justifiAuthToken"
                [checkoutId]="justifiCheckoutId"
                [isAvs]="isAvs"
                [isCanada]="country === 'ca'"
                [isAgreementChecked]="acknowledged"
                [merchantName]="googlePayMerchantName"
                [user]="user"
                (justifiReady)="setJustifiInitialized($event)">
    </ua-justifi>
  </ng-container>
  <ng-container *ngIf="paymentProcessorVersion === 1">
    <ua-payment (dropinCreated)="setDropin($event)"></ua-payment>
  </ng-container>
  <div *ngIf="braintreeError" class="alert alert-danger text-center mt-2" role="alert">
    {{braintreeError}}
  </div>
  <div *ngIf="justifiError" class="alert alert-danger text-center mt-2" role="alert">
    {{justifiErrorMsg ? justifiErrorMsg : "Please check your card information"}}
  </div>
</div>

<div class="mt-3">
  <!-- `paying ||` blocks double-clicks while a deposit submission is in flight (STORE-203). -->
  <button class="btn btn-primary btn-lg w-100 fw-bold" (click)="payNow()"
          [disabled]="paying || !paymentInitialized || !acknowledged || (paymentProcessorVersion === 2 && !useDefaultCard && !addNewCard && !defaultCardValue)">Pay</button>
</div>
<div class="my-4">
  <button class="btn btn-outline-primary btn-lg w-100 fw-bold" (click)="back()">Go Back</button>
</div>
